<template>
  <div class="Trio-funnel-form Trio-body-wrapper">
    <form style="padding: 0 50px">
      <personal-form :is-valid-email="isValidEmail"></personal-form>
      <check-box-form></check-box-form>
      <loader v-if="loading"></loader>
      <div v-else class="Trio-btn-row">
        <button-next
          :is-disabled="!isFullData || !isValidEmail || loading"
          @clicked="requestMortgage"
        >
          Solicitar
        </button-next>
      </div>
    </form>
  </div>
</template>

<script>
import { Store } from "../store/index";
import personalForm from "./personalForm.vue";
import buttonNext from "./buttonNext.vue";
import { mapActions, mapState } from "vuex";
import checkBoxForm from "./checkBoxForm.vue";
import loader from "./loader.vue";

export default {
  name: "affordForm",
  components: { personalForm, buttonNext, checkBoxForm, loader },
  computed: {
    ...mapState("ui", ["loading"]),
    isValidEmail() {
      if (Store.getters["personalData/email"]) {
        return Store.getters["personalData/isValidEmail"];
      }
      return true;
    },
    isFullData() {
      return Store.getters["personalData/isFullPersonalData"];
    },
  },
  methods: {
    ...mapActions("mortgageAfford", ["requestMortgage"]),
  },
};
</script>